module.exports = __webpack_public_path__ + "static/spark-centre-97602ea953bfb40fc25acce2bb86a2aa.png";